const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 1.03H3c-1.66 0-3 1.34-3 3V20.04c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3v-16c0-1.67-1.34-3.01-3-3.01zm-18 2h18c.55 0 1 .45 1 1v12.59l-4.29-4.29a.996.996 0 00-1.41 0L13 15.61l-5.29-5.29a1 1 0 00-1.41-.01L2 14.61V4.03c0-.56.45-1 1-1z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 14.97,
  cy: 7.03,
  r: 3
});

const SvgAttachImage = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attach-image.99e91d2c.svg";
export { ForwardRef as ReactComponent };